const hostname = window.location.hostname;
const isRfp = hostname.includes('rfp.');

export const AGENT_NAME = isRfp
  ? 'Section RFP Data Agent'
  : 'Series B Data Room Agent';

export const AGENT_TAGLINE = isRfp
  ? 'AI-powered access to RFP and compliance documents'
  : 'AI-powered access to Series B fundraising materials';

export const AGENT_PROMPT = isRfp
  ? 'Ask me anything about Section\'s security, compliance, policies, or architecture.'
  : 'Ask me anything about Section\'s financials, strategy, team, or operations.';

export const AGENT_PROMPT_SHORT = isRfp
  ? 'Ask questions about our security, compliance, and policies'
  : 'Ask questions about our financials, strategy, and team';

export const DATA_ROOM_LABEL = isRfp
  ? 'Accessing RFP data room'
  : 'Accessing investor data room';
